import * as yup from 'yup';

const pkgSchema = yup
  .object()
  .shape({
    length: yup.number().when('$isCustom', {
      is: true,
      then: yup
        .number()
        .min(0.1, 'Parcel.lengthRequired')
        .typeError('Parcel.lengthRequired')
        .required('Parcel.lengthRequired'),
    }),
    width: yup.number().when('$isCustom', {
      is: true,
      then: yup
        .number()
        .min(0.1, 'Parcel.widthRequired')
        .typeError('Parcel.widthRequired')
        .required('Parcel.widthRequired'),
    }),
    height: yup.number().when('$isCustom', {
      is: true,
      then: yup
        .number()
        .min(0.1, 'Parcel.heightRequired')
        .typeError('Parcel.heightRequired')
        .required('Parcel.heightRequired'),
    }),
    weight: yup.number().when('$isCustom', {
      is: true,
      then: yup
        .number()
        .min(0.1, 'Parcel.weightRequired')
        .typeError('Parcel.weightRequired')
        .required('Parcel.weightRequired'),
    }),
  })
  .defined();

export default pkgSchema;
